import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M12.319 4.317v-2.36a.749.749 0 0 0-.75-.75h-7.13a.749.749 0 0 0-.75.75v2.36a2.6 2.6 0 0 0-2.43 2.83v4.07a.743.743 0 0 0 .75.75h2.11v2.07a.743.743 0 0 0 .75.75h6.27a.749.749 0 0 0 .75-.75v-2.07H14a.743.743 0 0 0 .75-.75v-4.07a2.6 2.6 0 0 0-2.431-2.83Zm-7.13-1.61h5.63v1.57h-5.63Zm5.2 10.58h-4.77v-2.77h4.77Zm2.86-2.82h-1.36v-.7a.755.755 0 0 0-.75-.75h-6.27a.749.749 0 0 0-.75.75v.7h-1.36v-3.32c0-.96.44-1.37 1.47-1.37h7.55c1.03 0 1.47.41 1.47 1.37Zm-.81-2.98a.885.885 0 0 1-1.77 0 .885.885 0 1 1 1.77 0Z';
const draw24px = 'M18,7.06V3a.75.75,0,0,0-.75-.75H6.78A.75.75,0,0,0,6,3V7.06a3.5,3.5,0,0,0-3.57,3.83v6a.76.76,0,0,0,.75.75H6.66V21a.75.75,0,0,0,.75.75H16.6a.75.75,0,0,0,.75-.75V17.62H20.8a.76.76,0,0,0,.75-.75v-6A3.5,3.5,0,0,0,18,7.06ZM7.53,3.75h9V7H7.53Zm8.32,16.5H8.16V15.49h7.69Zm4.2-4.13h-2.7V14.74A.74.74,0,0,0,16.6,14H7.41a.74.74,0,0,0-.75.75v1.38H4V10.89c0-1.61.8-2.35,2.51-2.35H17.54c1.71,0,2.51.74,2.51,2.35ZM18.71,11a1.11,1.11,0,1,1-1.1-1.1A1.1,1.1,0,0,1,18.71,11Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const PrinterIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'printer'));
PrinterIcon.displayName = 'PrinterIcon';
PrinterIcon.propTypes = Icon.propTypes;
PrinterIcon.renderIcon = props => /*#__PURE__*/React.createElement(PrinterIcon, props);
export default PrinterIcon;
//# sourceMappingURL=PrinterIcon.js.map